module.exports = __webpack_public_path__ + "static/img/39-北京科技大学附属中学1.5af42ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/39-北京科技大学附属中学1.png
// module id = SSZ0
// module chunks = 0